import React, { Component } from "react";
import { connect } from "react-redux";
import _size from "lodash/size";
import _includes from "lodash/includes";
import _keys from "lodash/keys";
//
import {
  formatMoney,
  getGenderName,
  getCountry,
  getHumanDuration,
  intervention,
} from "../utils";
import { formatBookingTime } from "../services/date";

import {
  getModelPaidServices,
  getUserServices,
  getBookingServices,
  getModelDiscount,
  getModelRate,
  getTotalPrice,
  getLocation,
  getLocationFee,
  getCity,
  isPremiumIn,
} from "../selectors";
import Screen from "./ConnectedScreen";
import FormField from "../components/FormField";
import RadioGroup from "../components/RadioGroup";
import PriceRecap from "../components/PriceRecap";
import Icon from "../components/Icon";
import Alert from "../components/Alert";
import PremiumAlert from "./PremiumAlert";

const CONTACT_PROVIDERS = [
  { name: "Phone", value: "phone" },
  { name: "LINE", value: "line" },
  { name: "WhatsApp", value: "whatsapp" },
  { name: "Telegram", value: "telegram" },
];

class BookScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorHash: "",
    };
  }

  enterSubmit(ev) {
    if (ev.key === "Enter") {
      this.props.sendBooking();
    }
  }

  componentDidUpdate() {
    const { errors, errorMessage } = this.props;

    if (!this.scrollToTop) {
      const errorHash = this.getErrorHash(errors);

      if (errorMessage || errorHash != this.state.errorHash) {
        this.scrollToTop = true;
        this.setState({ errorHash });
      }
    } else {
      this.scrollToTop = false;
    }
  }

  getErrorHash(errors) {
    return _keys(errors)
      .map((key) => key)
      .join("-");
  }

  render() {
    const {
      city,
      discount,
      isLoading,
      country,
      isPremium,
      model,
      booking,
      duration,
      modelPaidServices,
      modelRate,
      totalPrice,
      bookingServices,
      userServices,
      errors,
      errorMessage,
      locationFee,
      setBookingInput,
      setBookingService,
      sendBooking,
      goTo,
      location,
      phoneCountry,
    } = this.props;

    let focus;

    if (booking.fullname && booking.email && location !== null) {
      focus = "roomNumber";
    } else if (booking.fullname && booking.email) {
      focus = "location";
    } else if (booking.fullname) {
      focus = "email";
    } else {
      focus = "fullname";
    }

    const phoneCountryValue = `+${phoneCountry.callingCode} ${phoneCountry.name}`;

    const hasError = _size(errors) > 0 || !!errorMessage;

    const requiresPremium = !!model.acceptPremiumOnly && !isPremium;

    return (
      <Screen
        title="Confirm request"
        isActive
        prevLabel="Cancel"
        nextLabel={isLoading ? "Sending..." : "Send request"}
        onNext={sendBooking}
        nextDisabled={isLoading || requiresPremium}
        scrollToTop={this.scrollToTop}
      >
        <div className="screen__content">
          {hasError && (
            <Alert
              error
              text={
                errorMessage ??
                "Please review the form. Some information is missing or incorrect."
              }
            />
          )}
          <div className="alert alert--info">
            <div className="o-media">
              <img
                // src={`/escorts/${model.hash}/images/sm/${model.image.path}`}
                src={`/images/sm/${model.image.path}`}
                alt={model.name}
                className="o-media__img"
                width={80}
                height={80}
              />
              <div className="o-media__body">
                <p>
                  <strong>{model.name}</strong> ({getGenderName(model.genderId)}
                  )<br />
                  <span className="u-brand">
                    {formatBookingTime(booking.date, city.timezone)}
                  </span>
                  <br />
                  {getHumanDuration(duration)}
                </p>
                <p />
              </div>
            </div>
          </div>
          {requiresPremium && (
            <PremiumAlert
              className="u-mb-small"
              text={`${model.name} only accepts Premium members.`}
            />
          )}
          <div className="form">
            <FormField
              label="Name"
              value={booking.fullname || ""}
              placeholder="e.g. John Doe"
              help={
                booking.outcall
                  ? "Your name as per your hotel reservation."
                  : null
              }
              error={errors["fullname"]}
              onChange={(ev) => setBookingInput("fullname", ev.target.value)}
              autoFocus={focus === "fullname"}
              onKeyDown={(ev) => this.enterSubmit(ev)}
            />
            <FormField
              label="Email"
              type="email"
              value={booking.email || ""}
              placeholder="e.g. myemail@outlook.com"
              error={errors["email"]}
              onChange={(ev) => setBookingInput("email", ev.target.value)}
              isSensitive
              onKeyDown={(ev) => this.enterSubmit(ev)}
              autoFocus={focus === "email"}
            />
            <FormField
              pre={
                <div className="form__field">
                  <div className="input-icon">
                    <input
                      type="text"
                      className="form__control"
                      value={phoneCountryValue}
                      readOnly
                      onClick={(ev) => goTo("countries")}
                    />
                    <Icon name="keyboard_arrow_right" />
                  </div>
                </div>
              }
              label="Phone"
              value={booking.phone || ""}
              placeholder="e.g. 0949423504"
              error={errors["phone"]}
              onChange={(ev) => setBookingInput("phone", ev.target.value)}
              isSensitive
              onKeyDown={(ev) => this.enterSubmit(ev)}
              autoFocus={focus === "phone"}
              help={`Important! So ${model.name} can contact you.`}
            />

            <FormField
              label="Preferred method of contact"
              error={errors["contact_provider_id"]}
            >
              <RadioGroup
                name="contact_provider"
                values={CONTACT_PROVIDERS}
                selected={booking.contact_provider}
                onChange={(val) => {
                  setBookingInput("contact_provider", val);

                  if (
                    val === "whatsapp" &&
                    !booking.contact_provider_id &&
                    phoneCountry &&
                    booking.phone
                  ) {
                    setBookingInput(
                      "contact_provider_id",
                      `+${phoneCountry.callingCode}${booking.phone}`
                    );
                  } else {
                    setBookingInput("contact_provider_id", "");
                  }
                }}
              />
              {booking.contact_provider !== "phone" && (
                <input
                  type="text"
                  className="form__control"
                  value={booking.contact_provider_id}
                  placeholder={
                    booking.contact_provider === "line"
                      ? "LINE ID"
                      : booking.contact_provider === "whatsapp"
                      ? "WhatsApp phone. e.g. +441133205364"
                      : "Telegram ID"
                  }
                  onChange={(ev) =>
                    setBookingInput("contact_provider_id", ev.target.value)
                  }
                />
              )}
            </FormField>

            {booking.outcall && (
              <FormField label="Hotel or Condo" error={errors["location"]}>
                <div className="input-icon">
                  <input
                    type="text"
                    className="form__control"
                    value={location ? location.name : ""}
                    readOnly
                    autoFocus={focus === "location"}
                    onClick={(ev) => goTo("location")}
                    placeholder="Choose..."
                  />
                  <Icon name="keyboard_arrow_right" />
                </div>
              </FormField>
            )}
            {booking.outcall && locationFee > 0 && (
              <Alert
                info
                text={`Please note there is an additional charge of **+${formatMoney(
                  locationFee
                )} ${country.currencyCode}** to travel to _${location.name}_.`}
              />
            )}
            {booking.outcall && (
              <FormField
                label="Room number"
                value={booking.roomNumber || ""}
                placeholder="e.g. 147A"
                help={`${model.name} will meet you directly in your room.`}
                error={errors["roomNumber"]}
                onChange={(ev) =>
                  setBookingInput("roomNumber", ev.target.value)
                }
                onKeyDown={(ev) => this.enterSubmit(ev)}
                autoFocus={focus === "roomNumber"}
              />
            )}
            <FormField label="Special requests">
              <textarea
                rows="5"
                value={booking.message}
                className="form__control"
                placeholder="e.g. Specific uniform, ..."
                onChange={(ev) => setBookingInput("message", ev.target.value)}
              />
            </FormField>
            {modelPaidServices.length > 0 && (
              <div className="form__field">
                <label>Additional Services</label>
                {modelPaidServices.map((_serv) => {
                  const price = _serv.multiplier
                    ? _serv.multiplier * modelRate.amount
                    : _serv.price;

                  return (
                    <label key={_serv.id} className="radio">
                      <input
                        type="checkbox"
                        value={_serv.id}
                        checked={_includes(userServices, _serv.id)}
                        onChange={() => setBookingService(_serv.id)}
                      />
                      {_serv.name}{" "}
                      {Boolean(price) && (
                        <small>
                          (+ {formatMoney(price)} {country.currencyCode})
                        </small>
                      )}
                      {!price && <small>FREE</small>}
                    </label>
                  );
                })}
              </div>
            )}
            <hr className="u-mv" />
            <div className="form__field">
              <PriceRecap
                {...{
                  currency: country.currencyCode,
                  discount,
                  isPremium,
                  model,
                  modelRate,
                  duration,
                  locationFee,
                  services: bookingServices,
                  total: totalPrice,
                }}
              />
            </div>
            <hr className="u-mv" />
            <p className="u-mb">
              By confirming this request you are agreeing to our{" "}
              <a href="/terms" target="_blank">
                terms & conditions
              </a>
              .
            </p>
          </div>
        </div>
      </Screen>
    );
  }
}

// @connect
import {
  sendBookingAction,
  setBookingInputAction,
  setBookingServiceAction,
} from "../modules/booking/actions";

function mapState(state) {
  const { ajax, booking, countries } = state;
  const city = getCity(state);

  return {
    discount: getModelDiscount(state),
    city,
    country: getCountry(city.country_id),
    errorMessage: ajax.message,
    errors: booking.errors,
    locationFee: getLocationFee(state),
    booking,
    duration: booking.duration,
    isPremium: isPremiumIn(state),
    modelPaidServices: getModelPaidServices(state),
    modelRate: getModelRate(state),
    bookingServices: getBookingServices(state),
    totalPrice: getTotalPrice(state),
    userServices: getUserServices(state),
    location: getLocation(state),
    phoneCountry: countries.entities[countries.active] || null,
  };
}

function mapDispatch(dispatch) {
  return {
    setBookingService(serviceId) {
      dispatch(setBookingServiceAction(serviceId));
    },
    setBookingInput(name, value) {
      dispatch(setBookingInputAction(name, value));
    },
    sendBooking() {
      dispatch(sendBookingAction());
    },
  };
}

export default connect(mapState, mapDispatch)(BookScreen);
